module.exports = __webpack_public_path__ + "static/media/Waitin round.b1b332c7.png";